export default "__VITE_ASSET__D04ZE$RE__"